<div class="container">
  <div class="content-card">
    <h1 class="bold">{{ externalWorkerFullName$ | async }}</h1>
    <h2 class="content-card__header">{{ 'AF-EmploymentDetails' | translate }}</h2>
    <ul class="header__nav">
      <li class="header__item">
        <a [routerLink]="['/profile', workerId, 'contactInfo']" class="header__link">{{ 'WF-PersonalData' | translate
        }}</a>
      </li>
      <li class="header__item">
        <a [routerLink]="['/profile', workerId, 'additionalInfo']" class="header__link">{{ 'WF-AdditionalData' |
        translate }}</a>
      </li>
      <li class="header__item">
        <a [routerLink]="['/profile', workerId, 'statements']" class="header__link">{{ 'WF-Statements' | translate
        }}</a>
      </li>
      <li class="header__item">
        <a [routerLink]="['/profile', workerId, 'agreements']" class="header__link header__link--active">{{
        'WP-Agreements' | translate }}</a>
      </li>
      <li class="header__item">
        <a [routerLink]="['/profile', workerId, 'documents']" class="header__link">{{ 'WP-Documents' | translate }}</a>
      </li>
      <li class="header__item">
        <a [routerLink]="['/profile', workerId, 'declarations']" class="header__link">{{ 'WP-Declarations' | translate
        }}</a>
      </li>
      <ng-container>
        <li *hasPermissionToModule="moduleNames.Delegations; workerId: workerId" class="header__item">
          <a [routerLink]="['/profile', workerId, 'delegations']" class="header__link">{{ 'WP-Delegations' | translate
          }}</a>
        </li>
      </ng-container>
      <li *hasPermissionToModule="moduleNames.Timesheets; workerId: workerId" class="header__item">
        <a [routerLink]="['/profile', workerId, 'timesheets']" class="header__link">{{ 'WP-Timesheets' | translate
        }}</a>
      </li>
      <li *hasPermissionToModule="moduleNames.EmploymentHistory; workerId: workerId" class="header__item">
        <a [routerLink]="['/profile', workerId, 'employmentHistory']" class="header__link">{{ 'WF-EmploymentHistory' |
        translate }}</a>
      </li>
      <li *hasPermissionToModule="moduleNames.EmploymentSettings; workerId: workerId" class="header__item">
        <a [visibleWithPermissions]="['ManageAllExternalWorkersList', 'ManageMyExternalWorkersList']"
        [routerLink]="['/profile', workerId, 'settings']" class="header__link">{{ 'WP-Settings' | translate }}</a>
      </li>
    </ul>
  </div>
  <form [formGroup]="agreementFormGroup" autocomplete="off">
    <div class="content-card">
      <h2 class="content-card__header">{{ 'AW-BasicData' | translate }}</h2>

      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Company' | translate }}</mat-label>
            <mat-select formControlName="company">
              @for (company of listOfCompanies$ | async; track company) {
                <mat-option #matOption [value]="company.Id">{{
                company.Name | translate }}</mat-option>
              }
            </mat-select>
            @if (company.invalid && company.touched) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Employer' | translate }}</mat-label>
            <mat-select formControlName="employer" #employerSelect>
              @for (employer of listOfEmployers$ | async; track employer) {
                <mat-option #matOption [value]="employer.Id">{{
                  employer.Name | translate
                }}</mat-option>
              }
            </mat-select>
            @if (employer.invalid && employer.touched) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'EmployerObject' | translate }}</mat-label>
            <input #employerObjectInput matInput formControlName="employerObject"
              placeholder="{{ 'EmployerObject' | translate }}" [matAutocomplete]="autocompleteEmployerObject" />
              <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
                @for (employerObject of listOfEmployerObjects$ | async; track employerObject) {
                  <mat-option [value]="employerObject">
                    {{ employerObject.Name }}
                  </mat-option>
                }
              </mat-autocomplete>
              @if (employerObject.invalid && employerObject.touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          @if (orderItemActive && hasAssignOrderItemPermission) {
            <div class="col-12">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'OrderItem' | translate }}</mat-label>
                <mat-select formControlName="orderItem">
                  @for (item of listOfAvailableOrderItems$ | async; track item) {
                    <mat-option #matOption [value]="item">{{ item.Name
                      }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }

          @if (selectedEmployerObject?.HasWorkEmails) {
            <div class="col-12">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'WorkEmail' | translate }}</mat-label>
                <input matInput type="Email" placeholder="{{ 'WorkEmail' | translate }}" formControlName="workEmail" />
                @if (workEmail.invalid && workEmail.touched) {
                  <mat-error>
                    {{ 'InvalidField' | translate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }

          <div class="col-12 col-lg-12">
            @if (isMpkActive) {
              <mat-form-field appearance="outline">
                <mat-label>{{ 'MPK' | translate }}</mat-label>
                <input matInput placeholder="{{ 'MPK' | translate }}" formControlName="mpk" />
              </mat-form-field>
            }

            @if (selectedEmployerObject?.RequireSupervisorOnMultiAgreementsForm) {
              <mat-form-field *hasPermissionToModule="moduleNames.Supervisors" appearance="outline">
                <mat-label>{{ 'Supervisor' | translate }}</mat-label>
                <input matInput formControlName="supervisor" placeholder="{{ 'Supervisor' | translate }}"
                  [matAutocomplete]="autocompleteSupervisor" required />
                  <mat-autocomplete #autocompleteSupervisor="matAutocomplete" [displayWith]="displayValue">
                    @for (supervisor of listOfSupervisors$ | async; track supervisor) {
                      <mat-option [value]="supervisor">
                        {{ supervisor.Name }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                  @if (supervisor.invalid && supervisor.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              }
            </div>

            @if (selectedEmployerObject?.HasLocalization) {
              <div class="col-12">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Location' | translate }}</mat-label>
                  <input matInput formControlName="location" placeholder="{{ 'Location' | translate }}"
                    [matAutocomplete]="autocompleteLocation" required />
                    <mat-autocomplete #autocompleteLocation="matAutocomplete" [displayWith]="displayValue">
                      @for (location of listOfLocations$ | async; track location) {
                        <mat-option [value]="location">
                          {{ location.Name }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                    @if (location.invalid && location.touched) {
                      <mat-error>
                        {{ 'InvalidField' | translate }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              }
            </div>
          </div>

          <div class="content-card">
            <h2 class="content-card__header">{{ 'ContractType' | translate }}</h2>

            <div class="row">
              <div class="col-12 col-lg-6">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'AgreementType' | translate }}</mat-label>
                  <mat-select formControlName="agreementType">
                    @for (agreementType of listOfAgreementTypes$ | async; track agreementType) {
                      <mat-option [value]="agreementType.Id">
                        {{ agreementType.Name }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (agreementType.invalid && agreementType.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-12 col-lg-6">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'PaymentDeadline' | translate }}</mat-label>
                  <mat-select formControlName="paymentDeadline">
                    @for (paymentDeadline of listOfPaymentDeadlines$ | async; track paymentDeadline) {
                      <mat-option [value]="paymentDeadline.Id">
                        {{ paymentDeadline.Name }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (paymentDeadline.invalid && paymentDeadline.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              @if ((listOfOrganizationalUnits$ | async)?.length > 0) {
                <div class="col-12 col-lg-6">
                  <mat-form-field appearance="outline" (click)="onOrganizationalUnitClick()">
                    <mat-label>{{ 'OrganizationalUnit' | translate }}</mat-label>
                    <input matInput formControlName="organizationalUnit" [matAutocomplete]="autocompleteOrganizationalUnit" />
                    <mat-icon matSuffix>{{ 'expand_more' }}</mat-icon>
                    <mat-autocomplete #autocompleteOrganizationalUnit="matAutocomplete" [displayWith]="displayValue">
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              }
              @if ((listOfOrganizationalUnits$ | async)?.length > 0) {
                <div class="col-12 col-lg-6">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'ActivityGroup' | translate }}</mat-label>
                    <mat-select formControlName="jobTitle">
                      @for (jobTitle of listOfJobTitles$ | async; track jobTitle) {
                        <mat-option #matOption [value]="jobTitle.Id">{{
                          jobTitle.Name | translate
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              <div class="col-12">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'JobResponsibilities' | translate }}</mat-label>
                  <mat-select [compareWith]="compareResponsibilities" (keydown)="handleKeydown($event)"
                    formControlName="responsibilities" multiple>
                    <mat-select-trigger>
                      <mat-chip-set class="responsibilities-chip" cdkDropList cdkDropListOrientation="mixed"
                        (cdkDropListDropped)="drop($event)">
                        @for (selectedResponsibilitity of responsibilities.value; track selectedResponsibilitity) {
                          <mat-chip class="responsibilities-box" cdkDrag
                            (removed)="onResponsibilityRemoved(selectedResponsibilitity)" [removable]="true"
                            [matTooltip]="selectedResponsibilitity.Name">
                            {{ selectedResponsibilitity.Name }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                          </mat-chip>
                        }
                      </mat-chip-set>
                    </mat-select-trigger>
                    <mat-form-field style="position: sticky; top: -10px; z-index: 1">
                      <input matInput placeholder="{{ 'Search' | translate }}" (keyup)="onFiltered($event.target.value)" />
                    </mat-form-field>
                    @for (responsibility of filteredResponsibilities$ | async; track responsibility) {
                      <mat-option #matOption
                        [value]="responsibility">
                        {{ responsibility.Name | translate }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (responsibilities.invalid && responsibilities.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-12 col-lg-6">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'AgreementConclusionDate' | translate }}</mat-label>
                  <input matInput [matDatepicker]="pickConclusionDate" formControlName="conclusionDate"
                    [matDatepickerFilter]="conclusionDateFilter" required />
                    <mat-datepicker-toggle matSuffix [for]="pickConclusionDate"></mat-datepicker-toggle>
                    <mat-datepicker #pickConclusionDate></mat-datepicker>
                    @if (conclusionDate.invalid && conclusionDate.touched) {
                      <mat-error>
                        {{ 'InvalidField' | translate }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>

                <!-- <div class="col-12 col-lg-6">
                <mat-form-field appearance="outline">
                  <mat-label>Data obowiązywania umowy</mat-label>
                  <mat-date-range-input
                    [rangePicker]="campaignOnePicker"
                    [comparisonStart]="agreementFormGroup.value.pickEmploymentDateFrom"
                    [comparisonEnd]="agreementFormGroup.value.pickEmploymentDateTo"
                    >
                    <input matStartDate placeholder="Start date" formControlName="employmentDateFrom" />
                    <input matEndDate placeholder="End date" formControlName="employmentDateTo" />
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
                  <mat-date-range-picker #campaignOnePicker></mat-date-range-picker>
                </mat-form-field>
              </div> -->

              <div class="col-12 col-lg-6">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'EmploymentDateFrom' | translate }}</mat-label>
                  <input matInput [matDatepicker]="pickEmploymentDateFrom" formControlName="employmentDateFrom"
                    [matDatepickerFilter]="employmentDateFromFilter" (dateChange)="checkDays('change', $event)" required />
                    <mat-datepicker-toggle matSuffix [for]="pickEmploymentDateFrom"></mat-datepicker-toggle>
                    <mat-datepicker #pickEmploymentDateFrom></mat-datepicker>
                    @if (employmentDateFrom.invalid && employmentDateFrom.touched) {
                      <mat-error>
                        {{ 'InvalidField' | translate }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>

                <div class="col-12">
                  @if (indefiniteContractPossible) {
                    <mat-checkbox formControlName="isForIndefinitePeriod">
                      {{ 'AgreementForAnIndefinitePeriod' | translate }}
                    </mat-checkbox>
                  }
                </div>

                <div class="col-12 col-lg-6">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'EmploymentDateTo' | translate }}</mat-label>
                    <input matInput [matDatepicker]="pickEmploymentDateTo" formControlName="employmentDateTo"
                      [matDatepickerFilter]="employmentDateToFilter" (dateChange)="checkDays('change', $event)"
                      [required]="!isForIndefinitePeriod.value" />
                      <mat-datepicker-toggle matSuffix [for]="pickEmploymentDateTo"></mat-datepicker-toggle>
                      <mat-datepicker #pickEmploymentDateTo></mat-datepicker>
                      @if (employmentDateTo.invalid && employmentDateTo.touched) {
                        <mat-error>
                          {{ 'InvalidField' | translate }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div class="col-12" [ngClass]="selectedEmployerObject?.HasWorkPattern ? 'col-lg-3' : 'col-lg-6'">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'AF-NoticePeriod' | translate }}</mat-label>
                      <mat-select formControlName="noticePeriod" required>
                        @for (period of listOfNoticePeriods$ | async; track period) {
                          <mat-option [value]="period.Id">
                            {{ period.Name }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (noticePeriod.invalid && noticePeriod.touched) {
                        <mat-error>
                          {{ 'InvalidField' | translate }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  @if (selectedEmployerObject?.HasWorkPattern) {
                    <div class="col-12 col-lg-3">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'AF-WorkPattern' | translate }}</mat-label>
                        <mat-select formControlName="workPattern" required>
                          @for (pattern of listOfWorkPatterns$ | async; track pattern) {
                            <mat-option [value]="pattern.Id">
                              {{ pattern.Name }}
                            </mat-option>
                          }
                        </mat-select>
                        @if (workPattern.invalid && workPattern.touched) {
                          <mat-error>
                            {{ 'InvalidField' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  }
                </div>

                @if (hasAnyDescriptiveWageType$ | async) {
                  @for (wage of dataSource.data; track wage; let i = $index) {
                    @if (i < (dataSource.data.length - 1)) {
                      <mat-divider class="mobile-divider"></mat-divider>
                    }
                    <div class="row" formArrayName="wages">
                      <div class="col-3 const-height-col" [formGroupName]="i">
                        <mat-form-field fxFill appearance="outline">
                          <mat-label>{{ 'WageType' | translate }}</mat-label>
                          <mat-select formControlName="wageTypeId">
                            @for (wageType of listOfWageTypes$ | async | filterWageType : wages.value : i | filterWageTypeMaxCount : wages.value : i; track wageType) {
                              <mat-option
                                [value]="wageType.Id">
                                {{ wageType.Name }}
                              </mat-option>
                            }
                          </mat-select>
                          @if (wages.controls[i].get('wageTypeId').invalid && wages.controls[i].get('wageTypeId').touched) {
                            <mat-error
                              >
                              {{ 'InvalidField' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      @if (wages.controls[i].get('wageTypeId').value) {
                        @if (isDescriptiveType(wages.controls[i].get('wageTypeId').value)) {
                          <div class="col-4" [formGroupName]="i">
                            <mat-form-field fxFill appearance="outline" class="dynamic-height-form">
                              <mat-label>{{ getWageTypeName(wages.controls[i].get('wageTypeId').value) }}</mat-label>
                              <textarea matInput formControlName="name" maxLength="2000" rows="1"></textarea>
                              @if (wages.controls[i].get('name').invalid && wages.controls[i].get('name').touched) {
                                <mat-error>
                                  {{ 'InvalidField' | translate }}
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <div class="col-4" [formGroupName]="i">
                            <mat-form-field fxFill appearance="outline" class="dynamic-height-form">
                              <mat-label>{{ 'CalculationDescription' | translate }}</mat-label>
                              <textarea matInput formControlName="calculationDescription" maxLength="2000" rows="1"></textarea>
                              @if (wages.controls[i].get('calculationDescription').invalid && wages.controls[i].get('calculationDescription').touched) {
                                <mat-error
                                  >
                                  {{ 'InvalidField' | translate }}
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                        } @else {
                          <div class="col-3" [formGroupName]="i">
                            <mat-form-field fxFill appearance="outline">
                              <mat-label>{{ 'Wage' | translate }}</mat-label>
                              <input matInput type="number" class="text-center" formControlName="value" min="0" required />
                              @if (wages.controls[i].get('value').invalid && wages.controls[i].get('value').touched) {
                                <mat-error>
                                  {{ 'InvalidField' | translate }}
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <div class="col-2" [formGroupName]="i">
                            <mat-form-field fxFill appearance="outline">
                              <mat-label>{{ 'Currency' | translate }}</mat-label>
                              <mat-select formControlName="currencyId">
                                @for (currency of listOfCurrencies$ | async; track currency) {
                                  <mat-option [value]="currency.Id">
                                    {{ currency.Name }}
                                  </mat-option>
                                }
                              </mat-select>
                              @if (wages.controls[i].get('currencyId').invalid && wages.controls[i].get('currencyId').touched) {
                                <mat-error
                                  >
                                  {{ 'InvalidField' | translate }}
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <div class="col-3" [formGroupName]="i">
                            <mat-form-field fxFill appearance="outline">
                              <mat-label>{{ 'Description' | translate }}</mat-label>
                              <mat-select formControlName="wageDescriptionId">
                                <mat-option [value]="null"></mat-option>
                                @for (wageDescription of filterWageDescriptions(listOfWageDescriptions$ | async, i); track wageDescription) {
                                  <mat-option
                                    [value]="wageDescription.Id">
                                    {{ wageDescription.Name }}
                                  </mat-option>
                                }
                              </mat-select>
                              @if (wages.controls[i].get('wageDescriptionId').invalid && wages.controls[i].get('wageDescriptionId').touched) {
                                <mat-error
                                  >
                                  {{ 'InvalidField' | translate }}
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                        }
                      }
                      <div class="col-1 wage-action-column">
                        <button mat-icon-button color="primary" class="trash-button" (click)="deleteWage(i)"
                          [disabled]="wageCounter <= miminumWages">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  }
                } @else {
                  @for (wage of dataSource.data; track wage; let i = $index) {
                    <mat-divider class="mobile-divider"></mat-divider>
                    <div class="row" formArrayName="wages">
                      <div class="col-3" [formGroupName]="i">
                        <mat-form-field fxFill appearance="outline">
                          <mat-label>{{ 'Wage' | translate }}</mat-label>
                          <input matInput type="number" class="text-center" formControlName="value" min="0" required />
                          @if (wages.controls[i].get('value').invalid && wages.controls[i].get('value').touched) {
                            <mat-error>
                              {{ 'InvalidField' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-2" [formGroupName]="i">
                        <mat-form-field fxFill appearance="outline">
                          <mat-label>{{ 'Currency' | translate }}</mat-label>
                          <mat-select formControlName="currencyId">
                            @for (currency of listOfCurrencies$ | async; track currency) {
                              <mat-option [value]="currency.Id">
                                {{ currency.Name }}
                              </mat-option>
                            }
                          </mat-select>
                          @if (wages.controls[i].get('currencyId').invalid && wages.controls[i].get('currencyId').touched) {
                            <mat-error
                              >
                              {{ 'InvalidField' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-3" [formGroupName]="i">
                        <mat-form-field fxFill appearance="outline">
                          <mat-label>{{ 'WageType' | translate }}</mat-label>
                          <mat-select formControlName="wageTypeId">
                            @for (wageType of listOfWageTypes$ | async | filterWageType : wages.value : i | filterWageTypeMaxCount : wages.value : i; track wageType) {
                              <mat-option
                                [value]="wageType.Id">
                                {{ wageType.Name }}
                              </mat-option>
                            }
                          </mat-select>
                          @if (wages.controls[i].get('wageTypeId').invalid && wages.controls[i].get('wageTypeId').touched) {
                            <mat-error
                              >
                              {{ 'InvalidField' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-3" [formGroupName]="i">
                        <mat-form-field fxFill appearance="outline">
                          <mat-label>{{ 'Description' | translate }}</mat-label>
                          <mat-select formControlName="wageDescriptionId">
                            <mat-option [value]="null"></mat-option>
                            @for (wageDescription of filterWageDescriptions(listOfWageDescriptions$ | async, i); track wageDescription) {
                              <mat-option
                                [value]="wageDescription.Id">
                                {{ wageDescription.Name }}
                              </mat-option>
                            }
                          </mat-select>
                          @if (wages.controls[i].get('wageDescriptionId').invalid && wages.controls[i].get('wageDescriptionId').touched) {
                            <mat-error
                              >
                              {{ 'InvalidField' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-1 wage-action-column">
                        <button mat-icon-button color="primary" class="trash-button" (click)="deleteWage(i)"
                          [disabled]="wageCounter <= miminumWages">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  }
                }

                <button mat-raised-button color="primary" type="button" (click)="addNewWage()">
                  <mat-icon>add_box</mat-icon>
                  <span>{{ 'AF-AddWage' | translate }}</span>
                </button>
              </div>

              @if (selectedEmployerObject?.HasPreliminaryMedicalExaminationRequirements) {
                <div class="content-card">
                  <h2 class="content-card__header">{{ 'OccupationalMedicineResearch' | translate }}</h2>
                  <div class="row row--checkbox">
                    <div class="col-12">
                      <mat-checkbox formControlName="preliminaryMedicalExamination">
                        {{ 'AF-PreliminaryMedicalExaminationRequirements' | translate }}
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
              }
              @if (this.isLegalizationFieldVisible()) {
                <div
                  [visibleWithPermissions]="['LegalizationInformationVisibilityToAll', 'LegalizationInformationVisibilityToEmployerObjects']"
                  class="content-card">
                  <h2 class="content-card__header">{{ 'Legalization.LegalizationStatus' | translate }}</h2>
                  <div class="row">
                    <div class="col-2">
                      <app-legalization-status-info [element]="workerAgreementLegalizationData" [size]="'large'"
                      [showStatusText]="true" [showTooltip]="false"></app-legalization-status-info>
                    </div>
                    <div class="col-2">
                      <button mat-raised-button class="legalization-status-btn" (click)="onSubmitForLegalization()" type="button"
                        [matTooltip]="'Legalization.SubmitForLegalizationInfo' | translate">
                        {{ 'Legalization.SubmitForLegalization' | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              }

              <div class="content-card">
                <h2 class="content-card__header">{{ 'AF-TheSetOfDocumentsVersion' | translate }}</h2>

                <div class="row">
                  <div class="col-12 col-lg-6">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'AF-TheSetOfDocumentsVersion' | translate }}</mat-label>
                      <mat-select formControlName="agreementTemplate" required>
                        @for (template of listOfAgreementTemplates$ | async; track template) {
                          <mat-option [value]="template.Id">
                            {{ template.Name }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (agreementTemplate.invalid && agreementTemplate.touched) {
                        <mat-error>
                          {{ 'InvalidField' | translate }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>

                  <div class="col-12 col-lg-6 pt-10">
                    <button mat-raised-button color="primary"
                      [disabled]="agreementFormGroup.invalid || (isWagesCountValid$ | async)" (click)="onGenerateDocument()">
                      {{ 'AF-GenerateDocument' | translate }}
                    </button>
                  </div>
                </div>
              </div>


            </form>
          </div>